export default "/images/Gustav.gif?c6c97ffe27d3f957c38d70c2ad97a918";